export default 'skill-bites-detail-page'
